import type { PermissionNameUnionType } from '@api';
import { PermittedItemType, useFilterPermittedItems } from '@common';
import { useMatches } from '@tanstack/react-router';

export type TabConfigType<TValue extends string = string> =
  PermittedItemType<PermissionNameUnionType> & {
    value: TValue;
  };

type UseTabsReturnType<T extends TabConfigType> = {
  activeTab: T['value'] | undefined;
  allowedTabs: T[];
};

export const useTabs = <T extends TabConfigType>(
  tabs: T[]
): UseTabsReturnType<T> => {
  const { filterPermittedItems } = useFilterPermittedItems();
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1];

  const activeTab = tabs.find((tab) => lastMatch.id.includes(tab.value))?.value;
  const allowedTabs = filterPermittedItems(tabs);

  return { activeTab, allowedTabs };
};
